import { render, staticRenderFns } from "./NewAvatar.vue?vue&type=template&id=2212c9f3"
import script from "./NewAvatar.vue?vue&type=script&lang=js"
export * from "./NewAvatar.vue?vue&type=script&lang=js"
import style0 from "./NewAvatar.vue?vue&type=style&index=0&id=2212c9f3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports